import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import Gigs from './Gigs';

const Expertise = ({
  data,
  setData,
  domainKnowledge,
  gigs,
  setDisableSave,
  disableSave,
}) => {
  const [verify, setVerify] = useState({});
  const [domainKnowledgeData, setDomainKnowledgeData] = useState([]);
  const courseMap = {
    'data-science': 'Data Science',
    web3: 'Web Development',
  };

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      if (
        Object.values(domainKnowledge)[0].length === Object.keys(verify).length
      ) {
        setDisableSave({ ...disableSave, domainKnowledge: false });
      } else {
        setDisableSave({ ...disableSave, domainKnowledge: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (domainKnowledgeData.length > 0) {
      const domain = Object.keys(domainKnowledge)[0];
      setData({
        ...data,
        domainKnowledge: { [domain]: [...domainKnowledgeData] },
      });
    }
  }, [domainKnowledgeData]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          {Object.keys(domainKnowledge).length > 0 && (
            <span>{courseMap[Object.keys(domainKnowledge)[0]]}</span>
          )}
        </div>
        {/* </div> */}
        <div className='flex flex-col space-y-0 justify-center w-full py-6'>
          {domainKnowledge[Object.keys(domainKnowledge)[0]].length > 0 &&
            domainKnowledge[Object.keys(domainKnowledge)[0]].map(
              (exp, index) => {
                return (
                  <div className='flex items-center gap-14  px-4' key={index}>
                    <span className=' flex items-center w-3/4'>
                      <span className='ml-2'>
                        <div className=' flex flex-col space-y-1'>
                          <div className=' opacity-80 text-base'>{exp}</div>
                        </div>
                      </span>
                    </span>
                    <span className='w-1/4 flex items-center justify-between'>
                      <span className=' opacity-60 text-sm'>
                        Expertise {index + 1}
                      </span>
                      <span>
                        <IconButton
                          onClick={() => {
                            setVerify({ ...verify, [index]: 'yes' });
                            domainKnowledgeData.splice(index, 0, exp);
                            setDomainKnowledgeData([...domainKnowledgeData]);
                          }}
                          className='focus:outline-none'
                        >
                          <CheckCircle
                            htmlColor={
                              verify[index] === 'yes' ? '#76CE65' : 'inherit'
                            }
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setVerify({ ...verify, [index]: 'no' });
                            domainKnowledgeData.splice(index, 1);
                            setDomainKnowledgeData([...domainKnowledgeData]);
                          }}
                        >
                          <Cancel
                            htmlColor={
                              verify[index] === 'no' ? '#CC0000' : 'inherit'
                            }
                          />
                        </IconButton>
                      </span>
                    </span>
                  </div>
                );
              }
            )}
          {gigs?.length > 0 && (
            <Gigs
              setDisableSave={setDisableSave}
              gigs={gigs}
              data={data}
              setData={setData}
              disableSave={disableSave}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Expertise;
